// extracted by mini-css-extract-plugin
module.exports = {"container":"container--IncomingInvitations-ActivityInvitations-Activity-routes__3uzHA"};